export const TABLE_PAGE_SIZE = 10;
export const TABLE_PAGE_NUMBER = 1;
export const TABLE_SORT_ASC = 'ASC';
export const TABLE_SORT_DESC = 'DESC';
